// extracted by mini-css-extract-plugin
module.exports = {"alert":"style_alert__CaAgw","logo":"style_logo__c1Epi"};